



import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectColor } from '../../store/theme.color.slice';
import { Product } from '@/types/ProductType';
import { AppConfig } from '@/utils/AppConfig';
import { useTranslation } from "react-i18next";



export default function Item({ title, descriptionAR, descriptionEN, price, image }: Pick<Product, 'descriptionAR' | 'descriptionEN' | 'price' | 'image' > & { title: string }) {
    const spanRef = useRef<HTMLSpanElement>(null);
    const color = useSelector(selectColor);
  const { t } = useTranslation();



    useEffect(() => {
        if (spanRef.current) {
            spanRef.current.style.color = color
        }
    }, [color])
    return (
        <div>
            <div className="card bg-white flex flex-col sm:flex-row justify-between md:items-center gap-4 sm:gap-2 p-4 border rounded-md">
                <div className="flex flex-col gap-5 w-full sm:w-auto">
                    <div>
                        <h3 className="text-lg">{title}</h3>
                        <span className="text-slate-400">{t(descriptionEN, descriptionAR)}</span>
                    </div>
                    <span
                    dir='rtl'
                        ref={spanRef}
                        className="bg-[#F7F7F7] px-2 rounded-xl w-fit"
                    >
                        {price} {AppConfig.currency.icon(color,13)}
                    </span>
                </div>
                <div className="card-image  min-w-[130px] h-[100px] rounded-xl overflow-hidden">
                    <img
                        src={image}
                        alt=""
                        className="min-w-[130px] h-[100px] object-cover"
                    />
                </div>
            </div>
        </div>


    )
}
